import axios from "axios";


export const getManageJobsGridService = (queryStr) => {
    return axios.get(`api/ts/jobs/manage?${`$count=true&`}${queryStr}`);
};
export const getManageJobsServiceForExcel = (queryStr) => {
    return axios.get(`api/ts/jobs/excel?${queryStr}`);
};
